import { render } from "./AllNoticeCategories.vue?vue&type=template&id=ddbbf8bc"
import script from "./AllNoticeCategories.vue?vue&type=script&lang=js"
export * from "./AllNoticeCategories.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__